<template>
  <div class="loginPage">
    <header class="login__nav">
      <div class="navContainer">
        <a href="https://dev.pied.tech/">
          <img src="@/assets/images/header_logo.png" alt="Logo" />
        </a>
      </div>
    </header>
    <div class="login__content">
      <div class="login__wrapper">
        <form>
          <div class="login__fields">
            <h2 class="login__fields__header primaryHeader mb-4">Sign Up</h2>
            <div class="form-group">
              <label for="email" class="login__label">First Name</label>
              <input
                type="text"
                class="login__input"
                placeholder="Enter your first name"
                autocomplete="off"
                v-model.trim="first_name"
                @keypress="checkNumber"
              />
            </div>
            <div class="form-group">
              <label for="email" class="login__label">Last Name</label>
              <input
                type="text"
                class="login__input"
                placeholder="Enter your last name"
                autocomplete="off"
                v-model.trim="last_name"
                @keypress="checkNumber"
              />
            </div>
            <div class="form-group">
              <label for="email" class="login__label">Email</label>
              <input
                type="email"
                name="email"
                class="login__input"
                placeholder="Enter your email"
                autocomplete="new-password"
                v-model.trim="email"
              />
            </div>
            <div class="form-group mb-2">
              <label for="password" class="login__label">Password</label>
              <input
                type="password"
                name="password"
                id="password"
                class="login__input"
                autocomplete="new-password"
                placeholder="Enter your password"
                v-model.trim="password"
              />
            </div>
            <div class="login__forget">
              <p class="txt--xs text-danger"></p>
              <router-link :to="'/operator-login/'+invitation_uuid" class="ml-auto"
                >Have an Account? Sign In</router-link
              >
            </div>
          </div>
          <div class="login__submit mt-4">
            <ButtonWithSpinner
              class="
                button button--md button__loader button--primary
                login__button
              "
              :loading="button.loading"
              :success="button.success"
              :disabled="button.disabled"
              @click="registerUser"
              >Submit</ButtonWithSpinner
            >
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import ButtonWithSpinner from "@/components/Button";
export default {
  name: "SignUp",
  components: { ButtonWithSpinner },
  data() {
    return {
      first_name: '',
      last_name: '',
      email: '',
      password: '',
      invitation_uuid: '',
      button: {
        loading: false,
        success: false,
        disabled: false,
      },
    };
  },
  created() {
    this.email = this.$route.params.email;
    this.invitation_uuid = this.$route.params.uuid;
  },
  methods: {
    registerUser() {
      //Validate
      if(this.first_name.length==0) {
        this.$toasted.show("Please provide a first name!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.last_name.length == 0) {
        this.$toasted.show("Please provide a last name!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.email.length == 0) {
        this.$toasted.show("Please provide an email!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.password.length == 0) {
        this.$toasted.show("Please provide a password!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }
      if(this.password.length<8) {
        this.$toasted.show("Password must be at least 8 characters long and should contain at least one upper case and lower case letter, one special character, and one number!",{
          icon: 'times-circle',
          className: 'error-class'
        });
        return;
      }

      this.button.disabled = true;
      this.button.loading = true;
      this.button.success = false;

      this.axios.post(window.hostname+'/api/commercial/signup',{
        first_name: this.first_name,
        last_name: this.last_name,
        email: this.email,
        password: this.password,
        invitation_uuid: this.invitation_uuid,
        device_type: 1,
      })
      .then(res=> {
        this.button.disabled = false;
        this.button.loading = false;
        if(res.data.status) {
          this.button.success = true;
          this.$toasted.show("Account created successfully!",{
            icon: 'check-circle',
            className: 'success-class'
          });
          localStorage.setItem("commercial_token_new", res.data.access_token);
          localStorage.setItem("loader",res.data.user.loader);
          //store the operators access list
          localStorage.setItem("role", res.data.user.role);
          if (res.data.user.role == 'operator') {
            localStorage.setItem("commercial_access_list", JSON.stringify(res.data.user.access));
          }
          this.$router.push({name : 'Welcome'});
        }
        else {
          this.$toasted.show(res.data.message,{
            icon: 'times-circle',
            className: 'error-class'
          });
          this.password = '';

          if (typeof res.data.redirect_to_login !== 'undefined') {
            
              if(res.data.redirect_to_login==true){
                this.$router.push({ name: "Login" });
              }
          }
          
        }
      })
      .catch(err=> {
        this.button.disabled = false;
        this.button.loading = false;
        this.button.success = false;
        this.password = '';
        this.$toasted.show(err.response.data.message, {
          icon: "times-circle",
          className: "error-class",
        });
      })
    },
    checkNumber(evt) {
        var valid = (evt.which >= 48 && evt.which <= 57) || (evt.which >= 65 && evt.which <= 90) || (evt.which >= 97 && evt.which <= 122);
        if (!valid) {
            evt.preventDefault();
        }
    },
  },
};
</script>

<style></style>
